'use strict';

import ticketCompletedTemplate from './ticketCompleted.html';

var ticketCompletedController = function($window) {
    var vm = this;

    vm.$onInit = function() {
        $window.onbeforeunload = null;
    }
};

ticketCompletedController.$inject = [ '$window' ];

export var ticketCompletedComponent = {
    name: 'ticketCompleted',
    template: ticketCompletedTemplate,
    controller: ticketCompletedController,
    controllerAs: 'vm'
};

export var ticketCompletedRoute = {
    name: 'ticketCompleted',
    url: '/ticketCompleted',
    component: 'ticketCompleted'
};